"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NasdaqIconSvg_1 = __importDefault(require("../NasdaqIconSvg"));
var InfoCircle = function (props) { return (react_1.default.createElement(NasdaqIconSvg_1.default, __assign({}, props, { viewBox: "0 0 30 30", fill: "none" }),
    react_1.default.createElement("path", { d: "M15.2132 10.3281C14.6356 10.3281 14.1594 10.1614 13.7848 9.82776C13.4101 9.47828 13.2227 9.03349 13.2227 8.49339C13.2227 7.95329 13.4101 7.51645 13.7848 7.18286C14.1594 6.84926 14.6356 6.68247 15.2132 6.68247C15.8065 6.68247 16.2827 6.84926 16.6417 7.18286C17.0164 7.51645 17.2038 7.95329 17.2038 8.49339C17.2038 9.03349 17.0164 9.47828 16.6417 9.82776C16.2827 10.1614 15.8065 10.3281 15.2132 10.3281ZM13.5037 12.0676H16.9462V23.8863H13.5037V12.0676Z" }),
    react_1.default.createElement("path", { d: "M15 0C6.71631 0 0 6.71873 0 15C0 23.2861 6.71631 30 15 30C23.2837 30 30 23.2861 30 15C30 6.71873 23.2837 0 15 0ZM15 27.0968C8.3146 27.0968 2.90323 21.6876 2.90323 15C2.90323 8.31684 8.31484 2.90323 15 2.90323C21.6829 2.90323 27.0968 8.31478 27.0968 15C27.0968 21.6853 21.6876 27.0968 15 27.0968Z" }))); };
exports.default = InfoCircle;
//# sourceMappingURL=index.js.map